module.exports = "/static/assets/0bf7dd9a7d4bcb7d5bd704e6f1d9730e.png";